export default __webpack_public_path__ + "static/martin-457e69fbba0922df15aae8d651392366.jpg";